<template>
	<BarChart
		:chart-id="chartId"
		:chart-data="chartData"
		:chart-options="chartOptions"
		:dataset-id-key="datasetIdKey"
		class="bar-chart-container width-100 height-100"
	/>
</template>

<script>
import { Bar as BarChart } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
	name: 'Bar',
	components: { BarChart },
	props: {
		chartData: { type: Object, required: true },
		chartOptions: { type: Object, required: true },
		chartId: { type: String, default: 'bar-chart' },
		datasetIdKey: { type: String, default: 'label' },
	},
};
</script>
<style scoped lang="scss">
.bar-chart-container {
	::v-deep {
		canvas {
			width: 100% !important;
			height: 100% !important;
		}
	}
}
</style>
